<div class="vendor-card-widget">
  <div class="card-header">
    <app-title-field
      [title]="VendorStats.vendorStatsCardTitle"
      [icon]="'groups'"

      [showLink]="true"
      (click)="navigateToVendorStats()"
    ></app-title-field>

    <app-dropdown
      [label]="VendorStats.selectMonth"
      [options]="monthOptions"
      [(ngModel)]="selectedMonthValue"
      [valueKey]="'value'"
      [displayKey]="'label'"
      (dropdownChange)="handleMonthChange($event)">
    </app-dropdown>
  </div>

  <div *ngIf="isLoading" class="card-loading-overlay">
    <div class="card-spinner">
      <div class="spinner"></div>
      <span class="loading-text">Loading...</span>
    </div>
  </div>

  <div class="chart-and-summary" *ngIf="!isLoading && vendorStatsData && vendorStatsData.length > 0;else noDataTemplate">
    <div class="mini-chart-container vendor-stats-chart">
      <app-chart
        [type]="'bar'"
        [data]="chartData"
        [xKey]="'vendor'"
        [yKeys]="['totalCount']"
        [colorMap]="colorMap"
        [width]="(chartData && chartData.length > 3) ? chartWidth : 500"
        [height]="chartHeight"
      ></app-chart>
    </div>

    <div class="vendor-summary" >
      <div class="summary-header">
        <span class="col-asset">{{ VendorStats.vendor }}</span>
        <span class="col-number">{{ VendorStats.totalHeadCount }}</span>
      </div>
      <div class="summary-rows">
        <div class="summary-row"
             *ngFor="let row of vendorStatsData; let i = index; trackBy: trackByVendor">
          <span
            class="legend-marker"
            aria-hidden="true"
            [style.background-color]="getPaletteColor(i)">
          </span>
          <span class="col-vendor" [title]="row.vendorName">{{ row.vendorName }}</span>
          <span class="col-number">{{ row.vendorCount.toString().padStart(2, '0') }}</span>
        </div>
      </div>
    </div>
  </div>
  <ng-template #noDataTemplate>
      <section class="records-container" aria-label="Records section">
        <div class="empty-state">
          <ng-container *ngIf="isDataLoaded">
            <h3 class="empty-state-title">{{ errorMsg }}</h3>
          </ng-container>
          <img
            [src]="imageSrc"
            alt="No records illustration"
            class="empty-state-image"
          />
        </div>
      </section>
    </ng-template>
</div>
